export default __webpack_public_path__ + "static/franchise2-fd5be2e99a4c64af9ece131c5b8b7567.png";